export default __webpack_public_path__ + "static/media/avatar_165.a616bf9f.png";